module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    class: 'login-' + _vm.view,
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.dingtalkHanded) ? _c('div', {
    staticClass: "dingtalk-handed"
  }, [_c('h2', [_vm._v("钉钉授权")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dingtalkHandedText))])]) : (_vm.view === 'select') ? _c('div', {
    staticClass: "identity-select"
  }, [_c('h2', [_vm._v(_vm._s(_vm.welcomeText))]), _vm._v(" "), _c('p', {
    staticClass: "identity-tip"
  }, [_vm._v("请选择登录身份")]), _vm._v(" "), _c('div', {
    staticClass: "identity-row"
  }, [_c('div', {
    staticClass: "identity-item admin",
    on: {
      "click": _vm.enterAdmin
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact",
      "size": "36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "identity-name"
  }, [_vm._v("管理员登录")]), _vm._v(" "), _c('div', {
    staticClass: "identity-desc"
  }, [_vm._v("使用钉钉授权，或用手机钉钉扫码。确认后在这台电脑登录。")])], 1), _vm._v(" "), _c('div', {
    staticClass: "identity-item agent",
    on: {
      "click": _vm.enterAgent
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-people",
      "size": "36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "identity-name"
  }, [_vm._v("代理登录")]), _vm._v(" "), _c('div', {
    staticClass: "identity-desc"
  }, [_vm._v("使用账号和密码登录，提交后继续短信验证。")])], 1)])]) : (_vm.view === 'admin') ? _c('div', {
    staticClass: "admin-login"
  }, [_c('h2', {
    staticClass: "admin-title"
  }, [_vm._v("管理员登录")]), _vm._v(" "), (_vm.chooseAccounts.length) ? _c('div', {
    staticClass: "account-choose"
  }, [_c('p', {
    staticClass: "view-tip"
  }, [_vm._v("该钉钉绑定了多个后台账号，请选择要登录的账号")]), _vm._v(" "), _vm._l((_vm.chooseAccounts), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "account-item",
      class: {
        'account-item-disabled': _vm.chooseLoading
      },
      on: {
        "click": function($event) {
          return _vm.chooseLogin(item)
        }
      }
    }, [_c('div', {
      staticClass: "account-name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "account-sub"
    }, [_c('span', [_vm._v("登录账号：" + _vm._s(item.account))]), _vm._v(" "), _c('span', [_vm._v("编号：" + _vm._s(item.id))])])])
  })], 2) : [_c('p', {
    staticClass: "view-tip"
  }, [_vm._v("请使用钉钉登录，未绑定钉钉的账号无法登录")]), _vm._v(" "), _c('div', {
    staticClass: "dingtalk-login"
  }, [_c('i-button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.dingtalkLoginLoading
    },
    on: {
      "click": _vm.dingtalkAuthLogin
    }
  }, [_vm._v("\n            钉钉授权登录\n          ")]), _vm._v(" "), (_vm.dingtalkWaiting) ? _c('p', {
    staticClass: "dingtalk-open-tip"
  }, [_vm._v("已打开钉钉，请在钉钉里确认授权，然后回到这个页面")]) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('a', {
    on: {
      "click": _vm.backToSelect
    }
  }, [_vm._v("返回身份选择")])])]], 2) : _c('div', {
    staticClass: "agent-login"
  }, [_c('h2', {
    staticClass: "agent-title"
  }, [_vm._v("代理登录")]), _vm._v(" "), _c('p', {
    staticClass: "view-tip"
  }, [_vm._v("请使用账号密码登录")]), _vm._v(" "), _c('i-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.loginForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "mobile", $$v)
      },
      expression: "loginForm.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "size": "large",
      "placeholder": "请输入密码"
    },
    on: {
      "on-enter": _vm.submit
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.loginForm.remember),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "remember", $$v)
      },
      expression: "loginForm.remember"
    }
  }, [_vm._v("记住密码")])], 1), _vm._v(" "), _c('Form-item', [_c('i-button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('a', {
    on: {
      "click": _vm.backToSelect
    }
  }, [_vm._v("返回身份选择")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code"
  }, [_c('div', {
    attrs: {
      "id": "dingtalk-qr"
    }
  }), _vm._v(" "), _c('p', [_vm._v("使用手机钉钉扫码，确认后在这台电脑登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc198014","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1942
// module chunks = 8